import { Capacitor } from "@capacitor/core";
import {
  createNativeScreenWakeLockAdapter,
  createScreenWakeLockController,
  createWebScreenWakeLockAdapter,
  type ScreenWakeLockController,
} from "@yjsgames/screen-wake-lock";
import { ScreenWakeLockNative } from "./screenWakeLockPlugin.js";

let controller: ScreenWakeLockController | null = null;

export function installScreenWakeLock(): ScreenWakeLockController {
  if (controller) return controller;
  const adapter = Capacitor.isNativePlatform()
    ? createNativeScreenWakeLockAdapter({ plugin: ScreenWakeLockNative })
    : createWebScreenWakeLockAdapter();

  controller = createScreenWakeLockController({
    adapter,
    document,
    window,
    autoStart: true,
  });
  return controller;
}
